<div id="content" class="main-content" style="margin-bottom: 22vh;">
    <div class="container">
      <div class="page-header">
        <div class="page-title col-lg-12 col-md-12 col-sm-12 col-xs-12 justify-content-between">
          <h2 class="col-sm-12 col-xs-12">
            <i class="flaticon-menu-list"></i><b> Mes tickets</b>
          </h2>
        </div>
      </div>
      <div>
        <div class="row" style="justify-content: end;">
          <div>
            <a type="button" class="btn btn-gradient-dark ml-2 mb-2 btn-rounded btn_new_customer" href="/support-req">
              <i class="flaticon-plus-1 mr-2"></i> Nouvelle demande
            </a>
          </div>
        </div>
  
        <div class="row">
          <div class="col col-lg-12">
            <div class="row" id="cancel-row">
              <div class="col-xl-12 col-lg-12 pr-0 pl-0 layout-spacing">
                <div class="statbox widget box box-shadow">
                  <div class="widget-header">
                    <div class="row">
                    </div>
                  </div>
                  <div class="widget-content widget-content-area pl-0 pr-1">
                    <div *ngIf="ticketsLoading" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 15%; margin-bottom: 15%;"></div>
                    <div class="table-responsive mb-4" *ngIf="!ticketsLoading">
                      <table id="alter_pagination" class="table table-striped table-bordered table-hover" style="width:100%">
                        <thead>
                          <tr>
                            <th>N° du ticket</th>
                            <th>Objet</th>
                            <th>Date de création</th>
                            <th>Crée par</th>
                            <th>Demandé par</th>
                            <th>Intensité</th>
                            <th>Modifié Le</th>
                            <th>Status</th>
                            <th>PJs</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let ticket of alltickets">
                            <td>
                              <a [attr.href]="'ticket/detail/' + ticket.uuid" class="ref_ticket">
                                <b>{{ ticket.ticketNumber }}</b>
                              </a>
                            </td>
                            <td>
                              {{ ticket.subject || '- - -' }}
                            </td>
                            <td>
                              {{ ticket.createdAt || '- - -' }}
                            </td>
                            <td>
                              {{ ticket.creator || '- - -' }}
                            </td>
                            <td>
                              {{ ticket.requestor || '- - -' }}
                            </td>
                            <td>
                              <span class="dot align-self-center mr-2" [ngClass]="{'dot-danger': ticket.intensityLevel ==='High', 'dot-success' : ticket.intensityLevel ==='Medium', 'dot-primary' : ticket.intensityLevel ==='Low'}"></span>{{ ticket.intensityLevel || '- - -' }}
                            </td>
                            <td>
                              {{ ticket.updatedAt || '- - -' }}
                            </td>
                            <td class="d-flex justify-content-center">
                              <span class="mb-2 ml-2 badge badge-pills" style="font-size: xx-small;" [ngClass]="{'badge-open': ticket.status ==='Ouvert', 'badge-resolved' : ticket.status ==='Résolu', 'badge-reprised' : ticket.status ==='Repris', 'badge-inProgress' : ticket.status ==='En cours', 'badge-waiting' : ticket.status ==='En attente', 'badge-clos' : ticket.status ==='Clos'}">{{ ticket.status || '- - -' }}</span>
                            </td>
                            <td>
                              <span *ngIf="!ticket.hasPj">- - -</span>
                              <span *ngIf="ticket.hasPj"><i class="flaticon-copy-line"></i> </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>    
              </div>
            </div>
          </div>
        </div>        
      </div>
    </div>
  </div>
  